<template>
  <div v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
    <LittleBanner />
    <p class="head-title">发起问答</p>
    <div class="form-content">
      <el-form :model="quesForm" :rules="rules" ref="quesForm" label-width="100px" style="max-width: 800px;margin: 0 auto;">
        <el-form-item label="标题" prop="title">
          <el-input v-model="quesForm.title"></el-input>
        </el-form-item>
        <el-form-item label="具体描述" prop="question">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入具体问题描述"
            v-model="quesForm.question">
          </el-input>
        </el-form-item>
        <el-form-item label="图片上传">
          <multiple-upload @uploadMultipleSuccess="uploadMultipleSuccess" />
        </el-form-item>
        <div style="text-align: center">
          <el-button type="primary" @click="onSubmit('quesForm')">立即提交</el-button>
          <el-button @click="backList">取消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import MultipleUpload from '@/components/MultipleUpload'
import LittleBanner from '../layout/components/LittleBanner'
import { submitForm } from '@/api/ques'
export default {
  name: 'Form',
  data() {
    return {
      loading: false,
      quesForm: {
        title: '',
        question: '',
        photos: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        question: [
          { required: true, message: '请输入具体问题描述', trigger: 'blur' }
        ],
      },
      photoArr: []
    }
  },
  components: {
    MultipleUpload,
    LittleBanner
  },
  methods: {
    uploadMultipleSuccess(arr) {
      this.photoArr = arr
    },
    backList() {
      this.$router.push('/ques/list')
    },
    onSubmit(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true
          that.quesForm.photos = that.photoArr.join(',')
          submitForm(that.quesForm)
            .then(res => {
              that.loading = false
              if (res.code === 200) {
                that.$notify({
                  title: '提交成功',
                  message: '请等待回复',
                  type: 'success',
                  duration: 2000
                })
                this.$router.push('/ques/list')
              }
            })
            .catch(() => {
              that.loading = false
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-content {
  max-width: 1200px;
  margin: 0 auto 20px;
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
.head-title {
  max-width: 1240px;
  margin: 30px auto 15px;
  font-size: 16px;
  font-weight: bold;
}
</style>
